import * as R from 'ramda';
import { useTranslation } from 'react-i18next';
// mui
import Box from '@mui/material/Box';
// components
import Icon from '../icons';
// constants
import * as C from '../../constants';
// ui
import { StyledLink } from '../../ui';
//////////////////////////////////////////////////

const contactItem = [
  {
    link: C.AMOUS_TMS_LOGIN,
    text: 'labels.amousTmsLogin',
  },
  {
    link: C.AMOUS_TMS_WEBSITE,
    text: 'labels.amousWebsite',
  },
];

const socialMediaNavLink = [
  {
    name: 'ln',
    linkTo: C.AMOUS_TMS_SOCIAL_MEDIA_LINKEDIN,
  },
  {
    name: 'instagram',
    linkTo: C.AMOUS_TMS_SOCIAL_MEDIA_INSTAGRAM,
  },
  {
    name: 'facebook',
    linkTo: C.AMOUS_TMS_SOCIAL_MEDIA_FACEBOOK,
  },
  {
    name: 'youtube',
    linkTo: C.AMOUS_TMS_SOCIAL_MEDIA_YOUTUBE,
  },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      px={4}
      width='100%'
      height='90px'
      display='flex'
      alignItems='center'
      justifyContent='space-between'
      backgroundColor={t => t.colors.middleGrey}
    >
      <Icon mr={30} name='logo' height='23px' width='119px' />
      <Box display='flex'>
        {
          contactItem.map(({ text, link }, index) => (
            <StyledLink
              mr={20}
              href={link}
              key={index}
              fontSize={18}
              target='_blank'
              textDecoration='none'
            >
              {t(text)}
            </StyledLink>
          ))
        }
      </Box>
      <Box display='flex'>
        {
          socialMediaNavLink.map(({ name, linkTo }, index) => (
            <StyledLink key={index} href={linkTo} target='_blank' ml={R.equals(0, index) ? 0 : 3}>
              <Icon
                width={24}
                height={24}
                name={name}
                cursor='pointer'
                color='linkColor'
                hoveredOpacity={0.7}
                hoveredTransform='scale(1.2)'
              />
            </StyledLink>
          ))
        }
      </Box>
    </Box>
  );
};

export default Footer;
